import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CruiseextrafiltersComponent } from './cruiseextrafilters.component';
import { AngularMaterialModule } from '../../material.module';
import { DirectiveModule } from '../../directives/directive.module';
import { MultiselectkModule } from '../multiselect/multiselect.module';
import { CruiseselectedfiltersComponent } from './cruiseselectedfilters/cruiseselectedfilters.component';
import { SelectionbtnModule } from '../selectionbtn/selectionbtn.module';
import { CruiseSearchlistModule } from '../filter/cruise/searchlist/searchlist.module';

@NgModule({
    declarations: [
        CruiseextrafiltersComponent,
        CruiseselectedfiltersComponent,
    ],
    imports: [
        CommonModule,
        AngularMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        DirectiveModule,
        MultiselectkModule,
        SelectionbtnModule,
        CruiseSearchlistModule
    ],
    exports: [
        CruiseextrafiltersComponent,
        CruiseselectedfiltersComponent
    ]
})
export class CruiseextrafiltersModule { }
